import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { EvaluationAthleteDialogEvaluationNewComponent } from '../dialog-evaluation-new/evaluation-athlete-dialog-evaluation-new.component';
import { EvaluationAthleteProvider } from '../../providers/evaluation-athlete-provider.services';
import { ArrayUtils } from "../../../common/providers/array-utils";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EvaluationAthleteRights } from '../../providers/evaluation-athlete-rights';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { CurrentUser } from "../../../common/providers/current-user";
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { EvaluationAthlete } from "../../../common/models/evaluation-athlete";
import { MatList, MatListItem } from "@angular/material/list";
import { MatLine } from "@angular/material/core";
import { MatChip, MatChipSet } from "@angular/material/chips";
import { MatDivider } from "@angular/material/divider";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { User } from "../../../common/models/user";

@Component({
  selector: 'evaluation-athlete-side-menu',
  providers: [],
  styleUrls: ['./side-menu.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatListItem,
    MatLine,
    MatList,
    MatChip,
    MatDivider,
    MatAccordion,
    MatExpansionPanelHeader,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatIcon,
    MatMenu,
    NgIf,
    MatMenuItem,
    MatMenuTrigger,
    MatIconButton,
    RouterLink,
    AppDatePipe,
    NgForOf,
    MatListItem,
    MatChipSet,
    MatButton,
    NgClass,
  ],
  templateUrl: './side-menu.html'
})
export class EvaluationAthleteSideMenuComponent implements OnInit, OnChanges, OnDestroy {

  public isLoading = true;

  public currentEvaluationType = '';
  @Input() public organization: Organization = {} as Organization;
  @Input() public athleteUser: User = {} as User;
  @Input() public evaluationAthlete: EvaluationAthlete = {} as EvaluationAthlete;
  @Input() public selectedEvaluations$: EventEmitter<Set<any>> | undefined;
  @Input() public selectedEvaluationsEvent$ = new EventEmitter<string>();
  private _selectedEvaluations = new Set<any>();
  @ViewChildren('evaluationCheckbox') evaluationCheckboxComponents: QueryList<any> | undefined;

  _evaluationsAthletes: EvaluationAthlete[] = [];
  get evaluationsAthletes(): EvaluationAthlete[] {
    return this._evaluationsAthletes;
  }
  @Input() set evaluationsAthletes(value: EvaluationAthlete[]) {
    this._evaluationsAthletes = value;
    this.evaluationsAthletesGrouped = this.arrayUtils.groupByAttribute(this._evaluationsAthletes, 'evaluation', 'type');
  }
  public evaluationsAthletesGrouped: EvaluationAthlete[] = [];

  public evaluationAthleteRights: EvaluationAthleteRights = new EvaluationAthleteRights(this.utils);
  // private is401: boolean = false;
  private subscriptions: Subscription[] = [];

  public getEvaluationAthletesType(evaluationAthletes: EvaluationAthlete[]): string[] {
    return Object.keys(evaluationAthletes);
  }

  public getEvaluationAthletesByType(type: string): EvaluationAthlete[] {
    return this.evaluationsAthletes.filter(ea => ea.evaluation!.type === type);
  }

  constructor(
    public conf: ConfigProvider,
    // public authorizationChecker: AuthorizationChecker,
    private utils: UtilsProvider,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toaster: MatSnackBar,
    private arrayUtils: ArrayUtils,
    private translator: TranslateService,
    private evaluationAthleteProvider: EvaluationAthleteProvider,
    private router: Router,
    private currentUserRoles: CurrentUserRolesProvider,
    private currentUser: CurrentUser,
  ) {
  }

  public ngOnInit() {
    this.initComponent();
  }

  public ngOnChanges(changes: SimpleChanges) {
    // if hcange has evaluationAthlete.id different, then reload component
    if (!changes['evaluationAthlete'])
      return;
    const previousEval: EvaluationAthlete = changes['evaluationAthlete'].previousValue;
    const currentEval: EvaluationAthlete = changes['evaluationAthlete'].currentValue;
    // si nouvelle eval selected : clean la liste seulement
    if (previousEval?.id !== currentEval.id) {
      this._selectedEvaluations = new Set<any>();
    }
    // si nouveau type d'eval alors on reset le component
    if (previousEval?.evaluationId !== currentEval.evaluationId) {
      this.resetComponent();
      this.initComponent();
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private resetComponent() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
    this._selectedEvaluations = new Set<any>();
    // Reset any other state if necessary
  }

  private initComponent() {
    this.loadData();
    this.currentEvaluationType = this.evaluationAthlete ? this.evaluationAthlete['evaluation']?.type ?? '' : '';

    const subscription = this.selectedEvaluationsEvent$.subscribe((event) => {
      const checkboxes = this.evaluationCheckboxComponents?.toArray();
      checkboxes?.forEach(cb => {
        if (!cb.nativeElement.disabled) {
          cb.nativeElement.checked = (event === 'all');
          cb.nativeElement.dispatchEvent(new Event('change'));
        }
      });
    });
    this.subscriptions.push(subscription);
  }

  public onNewClicked() {
    const dialogRef: any = this.dialog.open(EvaluationAthleteDialogEvaluationNewComponent, {
      data: {
        organization: this.organization,
        athleteUser: this.athleteUser,
        evaluationType: this.currentEvaluationType
      }
    });

    // Update the list by fetching all objects after dialog closed
    this.subscriptions.push(
      dialogRef.afterClosed().subscribe((data:any) => {
        if (data) {
          this.toaster.open(this.translator.instant('Evaluation_Added'), '', { duration: 5000 });
          this.router.navigate([this.organization!.code + '/athletes/' + this.athleteUser.id + '/evaluations/' + data.id]);
        }
      })
    );
  }

  public loadData() {
    this.evaluationAthleteRights.evaluateScreenRights({
      rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
    });
  }

  public onDeleteEvaluationClicked(evaluation: EvaluationAthlete) {

    const dialog: MatDialogRef<any> = this.dialog.open(ConfirmDialogComponent, {
      data: {
        confirmText: this.translator.instant('Confirm_delete_evaluation')
      }
    });

    this.subscriptions.push(
      dialog.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.isLoading = true;
          this.deleteEvaluation(evaluation).then(() => {
            this.isLoading = false;
            this.toaster.open(this.translator.instant('Evaluation_deleted'), '', {duration: 5000});
          })
            .catch((error: any) => this.onError(error));
        }
      })
    );
  }

  public onSelectEvaluation(event: any, evaluationAhtlete: any, index: number) {
    if (event.target.checked){
      this._selectedEvaluations.add(evaluationAhtlete);
    } else {
      this._selectedEvaluations.delete(evaluationAhtlete);
    }
    if (this.selectedEvaluations$) {
      this.selectedEvaluations$.emit(new Set(this._selectedEvaluations));
    }
  }

  private deleteEvaluation(evaluation: EvaluationAthlete): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.evaluationAthleteProvider.delete(this.organization.id!, evaluation).subscribe({
        next: () => {

          for (let i = 0; i < this.evaluationsAthletes.length; i++) {
            if (this.evaluationsAthletes[i].id === evaluation.id) {
              this.evaluationsAthletes.splice(i, 1);
              this.evaluationsAthletesGrouped = this.arrayUtils.groupByAttribute(this.evaluationsAthletes, 'evaluation', 'type');
              break;
            }
          }

          resolve(null);
        },
        error: (error: any) => reject(error)
      });
    });
  }

  private onError(error: any): void {
    this.isLoading = false;
  }

  protected readonly Athlete = Athlete;
}
